export default {
  vote: {
    title: 'Vote',
    category: 'Category',
    defi: 'Defi',
    description: 'Vote for projects you would like to see on Mito Launchpad',
    currentVotes: 'Current Votes',
    successToast: 'Voted Successfully!',

    whitelistedCount: 'Whitelisted address: ({count})',

    cta: 'Vote',
    votingOver: 'Voting over',
    votedCta: 'Your choice!',
    notWhitelisted: 'Not whitelisted'
  }
}
